import getProductName from "@helpers/products/getProductName";

import type { Product } from "@typings/product/product";
import type { GACartItem } from "@typings/analytics/google";

export const transformCartItemsToGA = (cartItems: Product[]): GACartItem[] => {
  return cartItems.map((cartItem, index) => {
    const { item, configuration } = cartItem;

    const primaryCategory = (item as any)?.category?.name || "Best Sellers";
    const secondaryCategory = (configuration as any)?.offer?.name || "Health & Wellness";

    return {
      index,
      item_id: item.id,
      item_name: getProductName(cartItem),
      item_category: primaryCategory,
      item_category2: secondaryCategory,
      price: configuration.price,
      quantity: configuration.quantity ?? 1,
      currency: "USD",
    };
  });
};
